module.exports = __webpack_public_path__ + "static/media/icon_behandlung_blank.d6fd876b.svg";